module.exports = __webpack_public_path__ + "static/media/deco.ac0e2d43.png";